import React, { useState, useRef } from "react";
import { useIntersection } from "@/components/common/UseIntersection";
import styles from "../TickerBanner/tickerBanner.module.scss";
import Ticker from "@/components/common/Counter";
import { useRouter } from "next/compat/router";
import { useSelector } from "react-redux";
import { getOverallBenefitValue } from "@/helpers/charityHelper";
import { useEffect } from "react";
import { set } from "lodash";

export default function TickerBanner({
  from,
  to,
  header,
  body,
  backgroundColor,
  alignment,
  enableText,
  bannerText,
  syncTotalImpact
}) {
  const isCentre = alignment == "Centre" ? true : false;
  const ref = useRef(null);
  const isInViewport = useIntersection(ref, "10px", false);
  const router= useRouter();
  const isPDP = router.asPath.includes("/products/");
  const isPWA = useSelector((state) => state.pwa.is_PWA);

  const [fromValue, setFromValue] = useState('')
  const [toValue, setToValue] = useState('')

  useEffect(() => {
    // Define an async function to fetch data
    const fetchData = async () => {
      try {
        // Check if syncTotalImpact is truthy
        if (syncTotalImpact) {
          // Call the getOverallBenefitValue function and await its response
          const resp = await getOverallBenefitValue();
          
          // Destructure the days_of_school property from the response object
          // If resp is falsy, days_of_school will be undefined
          const { days_of_school } = resp || {};
          
          // If days_of_school is falsy (e.g., undefined, 0, null, etc.), return early
          if (!days_of_school) return;
  
          // Calculate the values for setFromValue and setToValue
          setFromValue(days_of_school - 50000);
          setToValue(days_of_school);
        }
      } catch (error) {
        // If an error occurs, log it to the console
        console.log(error);
      }
    };
  
    // Call the fetchData function
    fetchData();
  
    // The empty array [] as the second argument to useEffect
    // ensures that the effect runs only once, on the initial render
  }, []);
  
  
  

  return (
    <>
    <div className={`mw-1440 bg-${backgroundColor.toLowerCase()} ${isPDP ? 'pdp-ticker-banner' : ''} ${isPWA && "addPaadingBottomToAPP"}`} ref={ref}>
        <div
          className={
            isCentre
              ? `${styles.ticker_wrapper} ${styles.centre_wrapper}`
              : `${styles.ticker_wrapper}`
          }
        >
          <div
            className={
              isCentre
                ? `${styles.content} ${styles.remove_flex}`
                : `${styles.content}`
            }
          >
            <div
              className={
                isCentre
                  ? `${styles.count} ${styles.centre_aligned}`
                  : `${styles.count}`
              }
            >
              {enableText ? (
                <h3 className="heading">
                  {bannerText}
                </h3>
              ) : (
                <h3 className="heading" alt="total benefit count">
                  {isInViewport && (
                      <Ticker from={fromValue!= ""?fromValue:from} end={toValue != ""?toValue:to}/>
                  )}
                </h3>
              )}
              <div
                className={
                  isCentre ? `large italic font-weight-350 ${styles.space}` : `large italic font-weight-350`
                }
              >
                {header}
              </div>
            </div>
            <div
              className={
                isCentre
                  ? `${styles.text} ${styles.alignment}`
                  : `${styles.text}`
              }
            >
              <div
                className="normal-md small-sm small-xs"
                dangerouslySetInnerHTML={{ __html: body }}
              ></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
